import type * as pf from '@amirada/lib-shared'
import { PfCmdType } from '@amirada/lib-shared'
import type * as tp from '@base/utils/types'
import { ut_capStore, ut_createParamDataString } from '@base/utils/utils'
import { usePfinderAPI } from '@base/composables/pfinderAPI'

export const useMaskStore = defineStore('maskStore', () => {
  const state: { [key: string]: pf.MaskNode } = reactive({})
  const pfinderAPI = usePfinderAPI()

  function cacheKey(paramData: tp.IParamData): string {
    // psn is part of the key: it narrows the server-side result set, so two requests differing only
    // in psn (e.g. a new quick-select duty point) are DIFFERENT masks — without it the client would
    // serve the previous duty point's mask.
    return [ut_createParamDataString(paramData),
      paramData.namePath,
      paramData.queryUrlServer.psx,
      (paramData.queryUrlServer.psn || []).join(',')].join('#')
  }

  async function callMaskData(paramData: tp.IParamData): Promise<pf.MaskNode | undefined> {
    const maskData = getMaskData(paramData)
    if (!maskData) {
      const args: pf.PfCmd<PfCmdType.MASK>['arg'] = {
        conf: paramData.namePath.split('/').splice(-1)[0] || '',
      }
      const data: tp.IFetchData = {
        paramData,
      }
      const res = await pfinderAPI.fetchData(PfCmdType.MASK, args, data)

      if (res && res.result) {
        setMaskData(paramData, res.result)
      }
      return getMaskData(paramData)
    }
    else {
      return maskData
    }
  }

  function setMaskData(paramData: tp.IParamData, data: pf.MaskNode): void {
    ut_capStore(state)
    state[cacheKey(paramData)] = data
  }

  function getMaskData(paramData: tp.IParamData): pf.MaskNode | undefined {
    return state[cacheKey(paramData)]
  }

  return {
    state,
    callMaskData,
    getMaskData,
    setMaskData,
  }
})
